import request from "../http/request";

export function login(data) {
    return request({
        url: process.env.VUE_APP_BASE_API + '/user/manage/putManagerLogin',
        method: 'post',
        data
    })
}

export function putManagerLogin(data) {
    return request({
        url: process.env.VUE_APP_BASE_API + '/user/manage/putManagerLogin',
        method: 'post',
        data
    })
}

export function getUserInfoByTokenInfo() {
    return request({
        url: process.env.VUE_APP_BASE_API +'/user/manage/getUserInfoByTokenInfo',
        method: 'post'
    })
}

export function logout() {
    return request({
        url: process.env.VUE_APP_BASE_API +'/user/manage/putEmpLogout',
        method: 'post'
    })
}

export function getAuthMenu(token) {
    return request({

        url: '/app/permission',
        method: 'get',
        params: { token }

    })
}

//客户信息查询
export function getCustomers(data) {
    return request({

        url: process.env.VUE_APP_BASE_API + '/user/manage/getCustomers',
        method: 'post',
        data
    })
}

//导入客户信息
export function putExcelUsersIn(file) {
    return request({

        url: process.env.VUE_APP_BASE_API + '/user/manage/putExcelUsersIn',
        method: 'post',
        data: file
    })
}

//导出excel表格
export function putExcelUsersOut() {
    return request({
        url: process.env.VUE_APP_BASE_API + '/user/manage/putExcelUsersOut',
        method: 'post'
    })
}

//导入企业信息
export function putExcelAuthIn(file) {
    return request({
        url: process.env.VUE_APP_BASE_API + '/user/manage/putExcelAuthIn',
        method: 'post',
        data: file
    })
}

//客户信息编辑
export function updateUserInfo(data) {
    return request({
        url: process.env.VUE_APP_BASE_API + '/user/manage/updateUserInfo',
        method: 'post',
        data
    })
}

//客户反馈管理(查询)
export function getComplians(params) {
    return request({
        url: process.env.VUE_APP_BASE_API + '/user/manage/getComplians',
        method: 'get',
        params
    })
}

//修改密码
export function editEmpPwd(data) {
    return request({
        url: process.env.VUE_APP_BASE_API + '/user/manage/editEmpPwd',
        method: 'post',
        data
    })
}

//顾问列表
export function getUserEmpList(data) {
    return request({
        url: process.env.VUE_APP_BASE_API + '/user/manage/getUserEmpList',
        method: 'post',
        data
    })
}

//顾问列表
export function queryAllEmpName(data) {
    return request({
        url: process.env.VUE_APP_BASE_API + '/user/manage/queryAllEmpName',
        method: 'post',
        data
    })
}